import gql from 'graphql-tag'

export const QUERY_KANBAN_CARDS_HOME = gql`
  query KanbanCards {
    kanbanCards(status: [OPEN, CONFIRMED, SEPARATION, AWAITING]) {
      _id
      status
      agent
      date
      time
      loyalty
      unit {
        _id
        id_erp
        name
        address
      }
      user {
        name
        phone
        document_no
        address {
          postal_code
          street
          neighborhood
          number
          complement
          city
          city_name
          federative_unit
        }
      }
      purchase {
        rate
        delivery_method
        document_on_fiscal_note
        missing_product_policy
        payment {
          payment_method
          exchange
        }
        cart {
          total_value
          products {
            ean
            name
            quantity
            unit_value
            total_value
            type
          }
        }
        timestamp
      }
      annotations
      comment
      purchase_value
    }
  }
`

export const MUTATION_UPDATE_KANBAN_CARD_STATUS = gql`
  mutation UpdateKanbanCardStatus($_id: ID!, $status: KanbanCardStatus!) {
    updateKanbanCardStatus(_id: $_id, status: $status) {
      _id
      status
      agent
      date
      time
      loyalty
      unit {
        _id
        id_erp
        name
        address
      }
      user {
        name
        phone
        document_no
        address {
          postal_code
          street
          neighborhood
          number
          complement
          city
          city_name
          federative_unit
        }
      }
      purchase {
        rate
        delivery_method
        document_on_fiscal_note
        missing_product_policy
        payment {
          payment_method
          exchange
        }
        cart {
          total_value
          products {
            ean
            name
            quantity
            unit_value
            total_value
            type
          }
        }
        timestamp
      }
      annotations
      comment
      purchase_value
    }
  }
`

export const MUTATION_UPDATE_KANBAN_CARD = gql`
  mutation UpdateKanbanCard($data: UpdateKanbanCardInput) {
    updateKanbanCard(data: $data) {
      _id
      status
      agent
      date
      time
      loyalty
      unit {
        _id
        id_erp
        name
        address
      }
      user {
        name
        phone
        document_no
        address {
          postal_code
          street
          neighborhood
          number
          complement
          city
          city_name
          federative_unit
        }
      }
      purchase {
        rate
        delivery_method
        document_on_fiscal_note
        missing_product_policy
        payment {
          payment_method
          exchange
        }
        cart {
          total_value
          products {
            ean
            name
            quantity
            unit_value
            total_value
            type
          }
        }
        timestamp
      }
      annotations
      comment
      purchase_value
    }
  }
`

export const QUERY_KANBAN_CARDS_HISTORY = gql`
  query KanbanCards {
    kanbanCards(status: [CONCLUDED, CANCELED]) {
      _id
      status
      agent
      date
      time
      loyalty
      unit {
        _id
        id_erp
        name
        address
      }
      user {
        name
        phone
        document_no
        address {
          postal_code
          street
          neighborhood
          number
          complement
          city
          city_name
          federative_unit
        }
      }
      purchase {
        rate
        delivery_method
        document_on_fiscal_note
        missing_product_policy
        payment {
          payment_method
          exchange
        }
        cart {
          total_value
          products {
            ean
            name
            quantity
            unit_value
            total_value
            type
          }
        }
        timestamp
      }
      annotations
      updated_at
      comment
      purchase_value
    }
  }
`
